import { Body } from "./Body";

export const HomePage = () => {
  return (
    <>
      <Body />
    </>
  );
};
